import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneCall } from 'lucide-react';

const PublicFooter = () => {
  return (
    <footer className="bg-[#050505] border-t border-white/5 py-16" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <PhoneCall size={24} className="text-[#FF3366]" />
              <span className="text-lg font-semibold text-white" style={{ fontFamily: "'Clash Display', sans-serif" }}>
                CallScript AI
              </span>
            </div>
            <p className="text-sm text-zinc-500 leading-relaxed">
              Transform call quality with AI-powered SOP compliance assessment.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-xs font-bold tracking-[0.2em] uppercase text-zinc-500 mb-4">Product</h4>
            <div className="space-y-2.5">
              <Link to="/capabilities" className="block text-sm text-zinc-400 hover:text-white transition-colors">Capabilities</Link>
              <Link to="/pricing" className="block text-sm text-zinc-400 hover:text-white transition-colors">Pricing</Link>
              <Link to="/reporting" className="block text-sm text-zinc-400 hover:text-white transition-colors">Reporting</Link>
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-bold tracking-[0.2em] uppercase text-zinc-500 mb-4">Company</h4>
            <div className="space-y-2.5">
              <Link to="/contact" className="block text-sm text-zinc-400 hover:text-white transition-colors">Contact Us</Link>
              <Link to="/contact" className="block text-sm text-zinc-400 hover:text-white transition-colors">Request Demo</Link>
            </div>
          </div>

          {/* Get Started */}
          <div>
            <h4 className="text-xs font-bold tracking-[0.2em] uppercase text-zinc-500 mb-4">Get Started</h4>
            <div className="space-y-2.5">
              <Link to="/login" className="block text-sm text-zinc-400 hover:text-white transition-colors">Login</Link>
              <Link to="/login?tab=register" className="block text-sm text-zinc-400 hover:text-white transition-colors">Sign Up</Link>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-600">&copy; {new Date().getFullYear()} CallScript AI. All rights reserved.</p>
          <div className="flex gap-6">
            <span className="text-xs text-zinc-600 hover:text-zinc-400 cursor-pointer">Privacy Policy</span>
            <span className="text-xs text-zinc-600 hover:text-zinc-400 cursor-pointer">Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter;
